<template>
    <div id="caseContainer">
        <!-- 第一屏 -->
        <Screen1></Screen1>
        <!-- 第二屏 -->
        <Screen2></Screen2>
        <!-- 第三屏 -->
        <Screen3></Screen3>
        <!-- 第四屏 -->
        <Screen4></Screen4>
        <!-- 第五屏 -->
        <Screen5></Screen5>
    </div>
</template>

<script>
import Screen1 from '@/components/case/Screen1.vue'
import Screen2 from '@/components/case/Screen2.vue'
import Screen3 from '@/components/case/Screen3.vue'
import Screen4 from '@/components/case/Screen4.vue'
import Screen5 from '@/components/case/Screen5.vue'

export default {
    name: 'Case',
    components: {
        Screen1,
        Screen2,
        Screen3,
        Screen4,
        Screen5,
    },
    mounted(){
        this.$store.state.activeIndex = "/case"
    }
}
</script>

